import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import HTTPMethod from 'http-method-enum';
import { API_MEDIA, API_TASKS, API_QUESTION_IDENTIFIER, API_TASKS_SKIP_INSTANCE, API_LATEST_FEEDBACK_PROMPT, API_DISMISS_FEEDBACK_PROMPT } from '@poplar/constants/routes';
import { FILE_GROUP_NAME } from '@yoweb/utils/file';
import { getPostOptions, safeFetch } from './utils';
var actions = {
  BATCH_UPLOAD: 'batch-upload',
  HANDOFF: 'handoff',
  MARK_STILL_OPEN: 'set-still-open',
  UPDATE_TO_DRAFT: 'update-to-draft'
};

var getTask = function getTask(taskId) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId), {
    method: HTTPMethod.GET
  });
};

var getTasks = function getTasks(taskViewType, options) {
  return safeFetch("".concat(API_TASKS, "?filter=").concat(taskViewType), _objectSpread(_objectSpread({}, options), {}, {
    method: HTTPMethod.GET
  }));
};

var getSubtasks = function getSubtasks(taskId) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId, "/subtasks"), {
    method: HTTPMethod.GET
  });
};

var completeTask = function completeTask(taskId, feedback) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId, "/complete"), getPostOptions(feedback));
};

var createTask = function createTask(task) {
  return safeFetch(API_TASKS, getPostOptions(task));
};

var deleteTask = function deleteTask(taskId) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId), {
    method: HTTPMethod.DELETE
  });
};

var handoffTask = function handoffTask(taskId) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId, "/").concat(actions.HANDOFF), {
    method: HTTPMethod.POST
  });
};

var markTaskStillOpen = function markTaskStillOpen(taskId, feedback) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId, "/").concat(actions.MARK_STILL_OPEN), getPostOptions({
    feedback: feedback
  }));
};

var updateTask = function updateTask(taskId, task) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId), _objectSpread(_objectSpread({}, getPostOptions(task)), {}, {
    method: HTTPMethod.PATCH
  }));
};

var updateTaskToDraft = function updateTaskToDraft(taskId) {
  return safeFetch("".concat(API_TASKS, "/").concat(taskId, "/").concat(actions.UPDATE_TO_DRAFT), {
    method: HTTPMethod.POST
  });
};

var skipNextRepeatingInstance = function skipNextRepeatingInstance(taskId) {
  return safeFetch(API_TASKS_SKIP_INSTANCE(taskId), {
    method: HTTPMethod.POST
  });
};

var getLatestFeedbackPrompt = function getLatestFeedbackPrompt() {
  return safeFetch(API_LATEST_FEEDBACK_PROMPT, {
    method: HTTPMethod.GET
  });
};

var dismissFeedbackPrompt = function dismissFeedbackPrompt(taskId) {
  return safeFetch(API_DISMISS_FEEDBACK_PROMPT(taskId), {
    method: HTTPMethod.POST
  });
};

var getQuestionIdentifier = function getQuestionIdentifier(questionIdentifier) {
  return safeFetch(API_QUESTION_IDENTIFIER, getPostOptions(questionIdentifier));
};

var reorderTasks = function reorderTasks(taskIds, taskViewType) {
  return safeFetch("".concat(API_TASKS, "/reorder"), getPostOptions({
    taskViewType: taskViewType,
    order: taskIds
  }));
};

var uploadFiles = function uploadFiles(files) {
  var formData = new FormData();
  files.forEach(function (_ref) {
    var file = _ref.file,
        fileName = _ref.fileName;
    formData.append(FILE_GROUP_NAME, file, fileName);
  });
  return safeFetch("".concat(API_MEDIA, "/").concat(actions.BATCH_UPLOAD), {
    method: HTTPMethod.POST,
    body: formData,
    headers: {
      Accept: 'application/json'
    }
  });
};

export { completeTask, createTask, deleteTask, getSubtasks, getTask, getTasks, handoffTask, markTaskStillOpen, reorderTasks, updateTask, updateTaskToDraft, uploadFiles, getQuestionIdentifier, skipNextRepeatingInstance, getLatestFeedbackPrompt, dismissFeedbackPrompt };